module.exports = __webpack_public_path__ + "media/banks/bank-wells-fargo-97497f4a.png";